<script setup lang="ts">
import { Refresh } from "@iconoir/vue";

// Declared so it does not fall through onto the root element as an attribute.
// The error itself is already reported via app.config.errorHandler.
defineProps<{ error: Error }>();

const reload = () => window.location.reload();
</script>

<template>
  <div class="loading-failed" role="alert">
    <span class="error">Etwas ist schiefgelaufen.</span>
    <button type="button" class="button button--secondary" @click="reload">
      <Refresh /> Seite neu laden
    </button>
  </div>
</template>

<style scoped>
.loading-failed {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  inline-size: 100%;
  block-size: 100%;
  text-align: center;
}
</style>
